<div id="SL20" class="block black flex-center-v">
    <div class="container">
        <div class="titlePage">
            <h1 class="headline_02_xl">{{package.title001}} <span class="bold">{{package.title002}}</span></h1>
            <h2 class="body_01_xl_light"><span class="bold">{{package.subtitle001}}</span> {{package.subtitle002}}</h2>
        </div>
        <div class="jobContainer">
            <div class="singleJob"  *ngFor="let job of package.jobs">
                <h1 class="body_03_xl_regular">{{job.company}}</h1>
                <p class="body_03_xl_regular"> <img src={{job.markerImg}} alt="locationMarker"> {{job.office}}</p>
                <p (click)="buttonClick(job.file)" class="body_03_xl_regular cursor">{{job.textLink}}</p>
            </div>
            
            
        </div>
    </div>
</div>
